// A mock function to mimic making an async request for data
import axios from "axios";
export function postFindPostalCode(adress) {
  return axios.post(
    `${process.env.REACT_APP_API_DOMAIN}/api/postalcode/`,
    adress
  );
}
